import PlayableZone from './PlayableZone'

export default class PlayableApp extends PlayableZone {}
